import { Alert, Snackbar } from '@mui/material'
import React, { ReactNode } from 'react'

export enum PopupNotificationType {
  SUCCESS = 'success',
  ERROR = 'error'
}

interface ShowPopupNotificationInput {
  message: string
  type: PopupNotificationType
}

type ShowNotificationFN = (input: ShowPopupNotificationInput) => void

interface PopupNotificationContextType {
  showPopupNotification: ShowNotificationFN
}

const PopupNotificationContext = React.createContext<PopupNotificationContextType>({
  showPopupNotification: (input: ShowPopupNotificationInput) => {}
})

export const PopupNotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const [notification, setNotification] = React.useState<ShowPopupNotificationInput>();

  const showPopupNotification = (input: ShowPopupNotificationInput): void => {
    setNotification(input)
    setOpen(true)
  }

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string): void => {
    if (reason === 'clickaway') {
      return;
    }
    setNotification(undefined);
    setOpen(false);
  };

  return (
    <PopupNotificationContext.Provider value={{ showPopupNotification }}>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert severity={notification?.type}>
          {notification?.message}
        </Alert>
      </Snackbar>
      {children}
    </PopupNotificationContext.Provider>
  )
}

export const useShowNotification = (): ShowNotificationFN => {
  const { showPopupNotification } = React.useContext(PopupNotificationContext)
  return showPopupNotification
}

export default PopupNotificationContext
